    $.featherlightGallery.prototype.afterContent = function() {
        var caption = this.$currentTarget.find('img').attr('data-caption');
     
        this.$instance.find('.caption').remove();
        $('<div class="caption">').html("<p>"+caption+"</p>").appendTo(this.$instance.find('.featherlight-content'));
        
    };

    $(".static-gallery-grid .static-gallery-card").on(
        "click",
        function (e) {
          e.preventDefault();
      
          let $this = $(this);
          let bioInfo = $($this.find(".static-gallery-img"));
          let bioName = bioInfo.attr("data-name") || "";
          let bioTitle = bioInfo.attr("data-caption") || "";
          let bioDesc = bioInfo.attr("data-description") || "";
          let bioTwitterLink = bioInfo.attr("data-twitter") || "";
          let bioLinkedinLink = bioInfo.attr("data-linkedin") || "";
          let bioImg = bioInfo.attr("src");
      
          $(".modal-name").text(bioName);
          $(".modal-title").text(bioTitle);
          $(".modal-body .img-block img").attr("src", bioImg);
          $(".modal-body .bio").html(bioDesc);
          if (bioTwitterLink.length) {
            $(".modal-body .twitter-link-block").css("display", "block");
            $(".modal-body .twitter-link").attr("href", bioTwitterLink);
          } else {
            $(".modal-body .twitter-link-block").css("display", "none");
          }
          if (bioLinkedinLink.length) {
            $(".modal-body .linkedin-link-block").css("display", "inline-block");
            $(".modal-body .linkedin-link").attr("href", bioLinkedinLink);
          } else {
            $(".modal-body .linkedin-link-block").css("display", "none");
          }
          $modals = $('.bio-modal');
          if( $modals.length > 0 ) {
            var modal = $modals[0];
            $(modal).modal('show');
          }
        }
      );

